module.exports = __webpack_public_path__ + "img/hr-H-B-3-unload-standup-shadow.19bebb69.png";